import * as Yup from 'yup'

export const validationSchema = (t) =>
  Yup.object().shape({
    date: Yup.date().nullable().required(t('form.required')),
  })
